import React from 'react';
import { BASE_URL } from 'utils/http';

const useCheckInternet = () => {
  const [hasInternet, setHasInternet] = React.useState(true);

  async function isAPIWorking() {
    return fetch(`${BASE_URL}/ping`);
  }

  React.useEffect(() => {
    (async () => {
      isAPIWorking()
        .then(() => {
          setHasInternet(true);
        })
        .catch(() => {
          setHasInternet(false);
        });
    })();

    function onlineStatusListener() {
      const status = navigator.onLine ? 'online' : 'offline';

      if (status === 'online') {
        const interval = setInterval(async () => {
          isAPIWorking()
            .then(() => {
              // Set state to `true` when user has internet
              setHasInternet(true);
              return clearInterval(interval);
            })
            .catch(() => {
              // Set state to `false` when user has internet
              setHasInternet(false);
            });
        }, 2000);
        return;
      }

      setHasInternet(false);
    }

    window.addEventListener('online', onlineStatusListener);
    window.addEventListener('offline', onlineStatusListener);

    return function cleanup() {
      window.removeEventListener('online', onlineStatusListener);
      window.removeEventListener('offline', onlineStatusListener);
    };
  }, []);

  return hasInternet;
};

export default useCheckInternet;
